import { UseControllerProvider, useController } from './hooks/useController';
import InvitationDetails from './pages/InvitationDetails';
import Invite from './pages/Invite';
import PreviewInvitation from './pages/PreviewInvitation';
import Schedule from './pages/Schedule';
import { UseSearchControllerProvider } from './pages/Schedule/components/Search/hooks/useSearchController';
import { Container } from './styles';

const pagesComponents = {
  schedule: <Schedule />,
  preview: <PreviewInvitation />,
  details: <InvitationDetails />,
  invite: <Invite />,
};

const Meetings: React.FC = () => {
  const { pageActive } = useController();

  return <Container>{pagesComponents[pageActive]}</Container>;
};

const MeetingsWrapper: React.FC = () => (
  <UseControllerProvider>
    <UseSearchControllerProvider>
      <Meetings />
    </UseSearchControllerProvider>
  </UseControllerProvider>
);

export default MeetingsWrapper;
